exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.borderRight[data-v-fff22cbc] {\n    border-right: 1px solid rgba(0, 0, 0, 0.12);\n}\n", ""]);
